import React from 'react'
import styled from 'styled-components'
import Sparkles from 'assets/homepage-redesign/assets/sparkles.svg'
import Pi from 'assets/homepage-redesign/assets/pi.svg'
import Experiment from 'assets/homepage-redesign/assets/experiment.svg'

const AssetWrapper = styled.div`
    width: 350px;
    height: 380px;
    border-radius: 24px;
    background: linear-gradient(180deg, #051e22 0%, #051f1b 100%);
    position: relative;
    box-shadow: 0px 12px 24px 0px #00000033, 0px 36px 36px 0px #0bd0bd80;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 18px;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 24px;
        padding: 5px;
        background: linear-gradient(180deg, #03cce6 0%, #0bd0bd 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }
    @media (max-width: 860px) {
        width: 300px;
        height: 325px;
        padding: 14px;
        border-radius: 20px;
        &::before {
            border-radius: 20px;
        }
    }
`

const ScanFrame = styled.div`
    width: 280px;
    height: 186px;
    border: 1.5px solid #ffffff;
    border-radius: 14px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 18px;
    gap: 14px;
    bottom: 46px;

    @media (max-width: 860px) {
        width: 240px;
        height: 160px;
        padding: 14px;
        gap: 10px;
        bottom: 40px;
    }
`

const ScanCorner = styled.div<{ position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' }>`
    position: absolute;
    width: 35px;
    height: 35px;
    pointer-events: none;

    ${({ position }) => {
        switch (position) {
            case 'topLeft':
                return `
                    top: -3px;
                    left: -3px;
                    border-top: 5px solid #ffffff;
                    border-left: 5px solid #ffffff;
                    border-top-left-radius: 10px;
                `
            case 'topRight':
                return `
                    top: -3px;
                    right: -3px;
                    border-top: 5px solid #ffffff;
                    border-right: 5px solid #ffffff;
                    border-top-right-radius: 10px;
                `
            case 'bottomLeft':
                return `
                    bottom: -3px;
                    left: -3px;
                    border-bottom: 5px solid #ffffff;
                    border-left: 5px solid #ffffff;
                    border-bottom-left-radius: 10px;
                `
            case 'bottomRight':
                return `
                    bottom: -3px;
                    right: -3px;
                    border-bottom: 5px solid #ffffff;
                    border-right: 5px solid #ffffff;
                    border-bottom-right-radius: 10px;
                `
        }
    }}
`

const ScanLine = styled.div<{ width: number }>`
    height: 14px;
    width: ${(props) => props.width * 1.2}px;
    background: #ffffff80;
    border-radius: 4px;
`

const IconsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: absolute;
    bottom: 35px;
    left: 58px;
    right: 0;
    width: 100%;

    @media (max-width: 860px) {
        bottom: 30px;
        left: 40px;
        gap: 8px;
    }
`

const MainIconWrapper = styled.div`
    width: 77px;
    height: 77px;
    border-radius: 100%;
    background: transparent;
    border: 4px solid #ffffff;
    box-shadow: 0px 0px 25px 0px #00000066;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    svg {
        scale: 0.9;
    }

    &::before {
        content: '';
        position: absolute;
        border-radius: 100%;
        border: 0.01em solid rgba(10, 10, 10, 0.7);
        display: none;
    }

    &::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border-radius: 100%;
        background: radial-gradient(50% 50% at 50% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%),
            linear-gradient(0deg, rgba(108, 62, 188, 0.9), rgba(108, 62, 188, 0.9));
        z-index: -1;
    }

    @media (max-width: 860px) {
        width: 65px;
        height: 65px;
        border-width: 3px;
        svg {
            scale: 0.8;
        }
    }
`
const SecondaryIconWrapper = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 100%;
    background: #008de8;
    border: 2px solid #ffffff26;
    box-shadow: 0px 0px 25px 0px #00000066;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        position: relative;
        right: 1px;
        scale: 0.9;
    }

    @media (max-width: 860px) {
        width: 44px;
        height: 44px;
        svg {
            scale: 0.8;
        }
    }
`

const TertiaryIconWrapper = styled.div`
    width: 45px;
    height: 45px;
    border-radius: 100%;
    background: #fc7600;
    border: 2px solid #ffffff26;
    box-shadow: 0px 0px 25px 0px #00000066;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        position: relative;
        scale: 1.2;
    }

    @media (max-width: 860px) {
        width: 38px;
        height: 38px;
        svg {
            scale: 1;
        }
    }
`

const HomeworkScanAsset: React.FC = () => {
    return (
        <AssetWrapper>
            <ScanFrame>
                <ScanCorner position="topLeft" />
                <ScanCorner position="topRight" />
                <ScanCorner position="bottomLeft" />
                <ScanCorner position="bottomRight" />
                <ScanLine width={90} />
                <ScanLine width={170} />
                <ScanLine width={150} />
                <ScanLine width={80} />
                <ScanLine width={110} />
            </ScanFrame>

            <IconsContainer>
                <MainIconWrapper>
                    <Sparkles />
                </MainIconWrapper>

                <SecondaryIconWrapper>
                    <Pi />
                </SecondaryIconWrapper>

                <TertiaryIconWrapper>
                    <Experiment />
                </TertiaryIconWrapper>
            </IconsContainer>
        </AssetWrapper>
    )
}

export default HomeworkScanAsset
